import { render } from "./FormSectionXxl.vue?vue&type=template&id=9a6efaa0&scoped=true"
import script from "./FormSectionXxl.vue?vue&type=script&lang=js"
export * from "./FormSectionXxl.vue?vue&type=script&lang=js"

import "./FormSectionXxl.vue?vue&type=style&index=0&id=9a6efaa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6efaa0"]])

export default __exports__